import { Header, Table } from "@tanstack/react-table";
import { useState } from "react";

import { NumericInput, InputGroup, Button } from "@blueprintjs/core";

interface IFIlterProps {
  header: Header<any, unknown>;
  table: Table<any>;
  onClose?: () => void;
  onSuccess?: () => void;
  onReset?: () => void;
}

export const Filter = ({
  header,
  table,
  onClose,
  onSuccess,
  onReset,
}: IFIlterProps) => {
  const [filterValue, setFilterValue] = useState(
    header.column.getFilterValue()
  );

  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(header.column.id);

  const handleSubmit = () => {
    header.column.setFilterValue(filterValue);
    onSuccess?.();
  };
  const handleReset = () => {
    header.column.setFilterValue(undefined);
    onReset?.();
  };
  const handleClose = () => {
    onClose?.();
  };

  if (typeof firstValue === "number") {
    const setValue = (value: number, index: number) => {
      const v = (filterValue as number[]) ?? [];
      v[index] = value;
      setFilterValue(Array.from(v));
    };
    return (
      <div className="p-2 h-full flex flex-col">
        <div className="flex gap-2">
          <NumericInput
            value={(filterValue as [number, number])?.[0]}
            fill
            onValueChange={(e) => setValue(e, 0)}
            placeholder="最小值"
          />
          <NumericInput
            value={(filterValue as [number, number])?.[1]}
            fill
            onValueChange={(e) => setValue(e, 1)}
            placeholder="最大值"
          />
        </div>
        <div className="flex-grow" />
        <div className="flex gap-2">
          <Button intent="primary" onClick={handleSubmit}>
            设置筛选条件
          </Button>
          <Button onClick={handleReset}>移除条件</Button>
        </div>
      </div>
    );
  } else if (typeof firstValue === "string" || !firstValue) {
    return (
      <div className="p-2 h-full flex flex-col">
        <div>
          <InputGroup
            value={(filterValue as string) ?? ""}
            onChange={(e) => setFilterValue(e.currentTarget.value)}
            placeholder="请输入"
          />
        </div>
        <div className="flex-grow" />
        <div className="flex gap-2">
          <Button intent="primary" onClick={handleSubmit}>
            设置筛选条件
          </Button>
          <Button onClick={handleReset}>重置</Button>
          <Button onClick={handleClose}>取消</Button>
        </div>
      </div>
    );
  } else {
    return (
      <div className="p-2 h-full flex flex-col">
        <div>未适配列类型，类型 {typeof firstValue}</div>
        <div className="flex-grow" />
        <div className="flex gap-2">
          <Button intent="primary" onClick={handleSubmit}>
            设置筛选条件
          </Button>
          <Button onClick={handleReset}>重置</Button>
          <Button onClick={handleClose}>关闭</Button>
        </div>
      </div>
    );
  }
};
